export class Email {
  private constructor(private readonly _value: string) {
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(_value)) {
      throw new Error(`Invalid email format: ${_value}`);
    }
  }

  static create(value: string): Email {
    return new Email(value.trim().toLowerCase());
  }

  get value(): string {
    return this._value;
  }

  toString(): string {
    return this._value;
  }
}
